﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class CZ02_2014 extends BaseForm
{
	override updateForm()
	{

	}
}